export default __webpack_public_path__ + "static/media/cross-word-splash.c81b8707.jpg";